<template>
  <div class="w-full flex flex-row bg-primary dark:bg-red-800 text-white">
    <div class="w-full h-[66px] md:h-[66px] mx-4 px-2 md:px-1 flex flex-row justify-between">
      <div class="w-full flex flex-row gap-4 items-center">
        <RouterLink v-if="!userStore.isLoggedIn" :to="{ name: 'home' }">
          <img
            v-if="breakpoints.greater('md').value"
            class="h-14"
            src="@/assets/images/logo.png"
            alt="Logo"
          />
          <img
            v-if="breakpoints.smallerOrEqual('md').value"
            class="h-14"
            src="@/assets/images/icon.png"
            alt="Logo"
          />
        </RouterLink>
        <div class="flex-grow">&nbsp;</div>
        <LanguageSwitcher />
        <div v-if="userStore.user">
          <VaAvatar
            :src="userStore.user.thumbnail_url || userStore.user.image_url"
            :fallback-text="
              userStore.user.first_name.charAt(0) + (userStore.user.last_name?.charAt(0) ?? '')
            "
          />
        </div>
        <div v-if="userStore.user">
          {{ userFullName }}
        </div>
        <VaButton
          v-if="!userStore.isLoggedIn && route.name !== 'login'"
          :to="{ name: 'login' }"
          size="large"
          plain
          color="white"
        >
          {{ t('header.login') }}
        </VaButton>
        <VaButton
          v-if="!userStore.isLoggedIn && route.name !== 'apply'"
          :to="{ name: 'apply' }"
          size="large"
          preset="secondary"
          color="white"
          border-color="white"
        >
          {{ t('header.apply') }}
        </VaButton>
        <VaPopover
          trigger="click"
          placement="bottom-right"
          auto-hide
          close-on-content-click
          color="red-700"
        >
          <VaButton
            v-if="userStore.isLoggedIn"
            size="large"
            preset="secondary"
            icon="menu"
            color="white"
          />

          <template #body>
            <MenuPopover />
          </template>
        </VaPopover>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaButton, VaPopover, VaAvatar } from 'vuestic-ui'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import MenuPopover from '@/components/MenuPopover.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const route = useRoute()
const userStore = useUserStore()
const { t } = useI18n()

const userFullName = computed(() => userStore.user?.first_name + ' ' + userStore.user?.last_name)
</script>
